import { Store } from '../types';
import api from '../utils/api';

/**
 * 从stores表获取所有店铺（使用前端API调用）
 */
export const getStoresFromApiKeys = async (): Promise<{id: number, name: string, address?: string, phone?: string, taxId?: string}[]> => {
  try {
    // 使用API调用而不是直接调用数据库
    const response = await api.get('/stores/from-keys');

    const storeListResponse = response.data;

    if (!storeListResponse || !Array.isArray(storeListResponse)) {
      console.error('无法获取店铺列表');
      return [];
    }

    const stores: { id: number; name: string; address?: string; phone?: string; taxId?: string }[] = [];
    for (const store of storeListResponse) {
      const rawId = store?.id ?? store?.store_id;
      const id = typeof rawId === 'string' ? parseInt(rawId, 10) : Number(rawId);
      if (!Number.isFinite(id) || id <= 0) continue;
      stores.push({
        id,
        name: store.name || store.store_name || `店铺 ${id}`,
        address: store.address || store.store_address || '',
        phone: store.phone || store.store_phone || '',
        taxId: store.taxId || store.store_tax_id || store.tax_id || ''
      });
    }
    return stores;
  } catch (error) {
    console.error('获取店铺列表失败:', error);
    throw error;
  }
};

/**
 * 获取所有店铺
 */
export const getStores = async (): Promise<Store[]> => {
  try {
    // 使用API调用而不是直接调用数据库
    const response = await api.get('/stores');
    const stores = response.data;

    // 转换为Store类型格式
    return stores.map((store: any) => ({
      id: store.id,
      name: store.name,
      address: store.address || '',
      contact: store.phone || '',
      manager: '',
      status: store.status || 'active'
    }));
  } catch (error) {
    console.error('获取店铺列表失败:', error);
    throw error;
  }
};

/**
 * 根据ID获取店铺
 */
export const getStoreById = async (id: number): Promise<Store> => {
  try {
    // 使用API调用而不是直接调用数据库
    const response = await api.get(`/stores/${id}`);
    const store = response.data;

    if (!store) {
      throw new Error('店铺不存在');
    }

    // 转换为Store类型格式
    return {
      id: store.id,
      name: store.name,
      address: store.address || '',
      contact: store.phone || '',
      manager: '',
      status: store.status || 'active'
    };
  } catch (error) {
    console.error(`获取店铺(ID: ${id})失败:`, error);
    throw error;
  }
};

/**
 * 添加新店铺
 */
export const addStore = async (store: Omit<Store, 'id' | 'created_at' | 'updated_at'>): Promise<Store> => {
  throw new Error('添加店铺功能暂未实现，请通过stores表管理店铺信息');
};

/**
 * 更新店铺信息
 */
export const updateStore = async (id: number, store: Partial<Store>): Promise<void> => {
  throw new Error('更新店铺功能暂未实现，请通过stores表管理店铺信息');
};

/**
 * 删除店铺
 */
export const deleteStore = async (id: number): Promise<void> => {
  throw new Error('删除店铺功能暂未实现，请通过stores表管理店铺信息');
};

